import { c as _c } from "react/compiler-runtime";
import { fetchGuideEmoticonList } from '@module/apis/client-side/guide';
import type { GuideEmoticonListResponse, GuideEmoticonParams } from '@module/apis/client-side/guide/type';
import type { CustomUseInfiniteQueryOptions } from '@module/queries/type';
import { useInfiniteQuery } from '@tanstack/react-query';
import { guideQueryKeys } from '../guideQueryKeys';
export const useGuideEmoticonListInfiniteQuery = (params, options) => {
  const $ = _c(11);
  let t0;
  if ($[0] !== params) {
    t0 = guideQueryKeys.fetchGuideEmoticonList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 0 : t3;
      const offset = typeof pageParam === "number" ? pageParam : 0;
      return fetchGuideEmoticonList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== params) {
    t2 = (lastPage, allPages) => {
      if (lastPage.page && lastPage.page.lastPage > allPages.length) {
        const limit = params.limit ?? 20;
        return allPages.length * limit;
      }
    };
    $[4] = params;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== options || $[7] !== t0.queryKey || $[8] !== t1 || $[9] !== t2) {
    t3 = {
      initialPageParam: 0,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: t2,
      select: _temp2
    };
    $[6] = options;
    $[7] = t0.queryKey;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return useInfiniteQuery(t3);
};
function _temp(page) {
  return page.list ?? [];
}
function _temp2(data) {
  const result = {
    list: data.pages.flatMap(_temp),
    page: data.pages[0].page,
    result: data.pages[0].result,
    message: data.pages[0].message
  };
  return result;
}